package com.vamvisions.main.core.presentation.i18n

/** French follows its typography: a non-breaking space (`\u00A0`) before `:`, `!` and `?`. */
object FrStrings : Strings {
    override val navHome = "Accueil"
    override val navPortfolio = "Portfolio"
    override val navProjects = "Projets"
    override val navContact = "Contact"
    override val mainNavigationLabel = "Navigation principale"
    override val skipToContent = "Aller au contenu principal"

    override val switchToDarkScheme = "Passer au thème sombre"
    override val switchToLightScheme = "Passer au thème clair"
    override val changeLanguage = "Changer de langue"

    override val homeTitle = "Accueil"
    override val portfolioTitle = "Portfolio"
    override val projectsTitle = "Projets"
    override val contactTitle = "Contact"
    override val notFoundTitle = "Page introuvable"

    override val notFoundMessage = "La page que vous recherchez n'existe pas."
    override val backToHome = "Retour à la page d'accueil"

    override val errorNoConnection = "Impossible de joindre le serveur. Vérifiez votre connexion et réessayez."
    override val errorNotFound = "Le contenu demandé est introuvable."
    override val errorServer = "Une erreur s'est produite sur le serveur. Veuillez réessayer plus tard."
    override val errorInvalidResponse = "Le serveur a envoyé une réponse illisible."
    override val errorUnknown = "Une erreur s'est produite. Veuillez réessayer."
    override val errorBadRequest = "Le message n'a pas pu être accepté. Vérifiez les champs et réessayez."
    override val errorTooManyRequests = "Trop de messages ont été envoyés. Veuillez réessayer plus tard."

    override val loading = "Chargement…"
    override val retry = "Réessayer"

    override val introTitle = "\uD83C\uDF40 Bonjour, je suis Ana Maria Vilcu"
    override val introSubtitle = "Je développe des applications Kotlin Multiplatform — et j’adore transformer des idées en produits " +
        "que les gens aiment utiliser."
    override val highlightExperienceUnit = "ans"
    override fun highlightExperienceTitle(years: Int) = "$years+ ans"
    override val highlightExperienceAccent = "d’expérience professionnelle"
    override val highlightExperienceText = "Je développe des applications Android depuis 2018, des terminaux de paiement et de la banque " +
        "aux applications grand public sur Google Play."
    override val highlightTechnicalTitle = "Compétences techniques"
    override val highlightTechnicalAccent = "Mentorat par Philipp Lackner et son équipe"
    override val highlightTechnicalText = "Des sessions de questions-réponses en direct avec Philipp et le soutien de son équipe sur Slack " +
        "pendant que je développe avec Kotlin Multiplatform."
    override val highlightBusinessTitle = "Compétences business"
    override val highlightBusinessAccent = "Mentorat par l’équipe Monetise d’Iman Gadzhi"
    override val highlightBusinessText = "Plusieurs sessions de questions-réponses chaque semaine pour faire grandir un produit et le " +
        "développer à grande échelle."

    override val connectTitle = "\uD83E\uDD1D Restons en contact"
    override val connectText = "Vous avez un projet en tête, une question sur mon travail ou simplement envie de dire bonjour\u00A0? " +
        "Ce sera un plaisir d'avoir de vos nouvelles."
    override val connectLink = "Me contacter"

    override val portfolioIntroTitle = "\uD83C\uDF31 Mon parcours jusqu’ici"
    override val portfolioIntroText = "Aujourd’hui, je développe des applications Kotlin Multiplatform sous mon propre nom, VAMVisions, " +
        "avec sept ans d’expérience dans des équipes produit Android et une année investie dans le développement de mes compétences."
    override val portfolioExperienceEyebrow = "Expérience"
    override val portfolioExperienceTitle = "Des équipes produit à mon propre studio"
    override val portfolioLearningEyebrow = "Formation en cours"
    override val portfolioLearningTitle = "Apprendre en continu"
    override val portfolioEducationEyebrow = "Études"
    override val portfolioEducationTitle = "Là où tout a commencé"
    override val portfolioSeeProjects = "Voir mes projets"
    override val portfolioWorkWithMe = "Travailler avec moi"

    override val contactIntroTitle = "\uD83D\uDC4B Parlons-en"
    override val contactIntroText = "Une idée d’application, un produit numérique en tête ou un partenariat à explorer\u00A0? Parlez-m’en un " +
        "peu. J’aurai plaisir à vous lire."
    override val contactPhotoAlt = "Ana Maria Vîlcu qui sourit dans un jardin japonais à Kyoto"
    override val contactReachTitle = "Me joindre directement"
    override val contactFormTitle = "Parlez-moi de votre projet"
    override val contactTopicLabel = "De quoi s’agit-il\u00A0?"
    override val contactOptional = "(facultatif)"
    override val contactTopicAppDevelopment = "Développement d’application"
    override val contactTopicDigitalProduct = "Création de produit numérique"
    override val contactTopicPartnership = "Partenariat"
    override val contactTopicOther = "Autre"
    override val contactNameLabel = "Nom (facultatif)"
    override val contactNamePlaceholder = "Comment dois-je vous appeler\u00A0?"
    override val contactEmailLabel = "Votre adresse e-mail"
    override val contactEmailPlaceholder = "vous@exemple.com"
    override val contactMessageLabel = "Message"
    override val contactMessagePlaceholder = "Quelques lignes sur votre idée, vos délais ou votre question…"
    override val contactSend = "Envoyer le message"
    override val contactSending = "Envoi en cours…"
    override val contactSent = "Merci\u00A0! Votre message a bien été envoyé. Je vous répondrai bientôt."
    override val contactSendFailed = "Une erreur s’est produite et votre message n’a pas été envoyé. Réessayez, ou écrivez-moi directement " +
        "par e-mail."
    override val errorFieldRequired = "Ce champ est obligatoire."
    override val errorEmailInvalid = "Veuillez saisir une adresse e-mail valide."
    override val errorMessageRequired = "Veuillez écrire un message."
    override val errorMessageTooShort = "Le message doit contenir au moins 10 caractères."
    override val errorMessageTooLong = "Le message doit contenir au plus 5000 caractères."
    override val errorNameTooLong = "Le nom doit contenir au plus 100 caractères."

    override val projectsIntroTitle = "\uD83D\uDEE0\uFE0F Ce que j’ai construit"
    override val projectsIntroText = "De mes premières applications Java sur Google Play aux produits Kotlin Multiplatform d’aujourd’hui. Chacune " +
        "m’a appris quelque chose que j’apporte à chaque nouveau projet."
    override val projectsNowEyebrow = "En ce moment"
    override val projectsNowTitle = "Ce que je construis"
    override val projectsEarlierEyebrow = "Premières applications · 2018–2021"
    override val projectsEarlierTitle = "Là où tout a commencé"
    override val projectsConnectTitle = "\uD83E\uDD1D Une idée d’application\u00A0?"
    override val projectsConnectText = "J’aimerais beaucoup en entendre parler. Voyons ensemble comment la concrétiser."
    override val comingSoon = "Bientôt disponible"
    override val visitSite = "Voir le site"
    override val privacyPolicy = "Politique de confidentialité"
    override val sourceCode = "Code source"

    override val documentTable = "Tableau"

    override val present = "aujourd'hui"
    override val shortMonthNames = listOf(
        "janv.", "févr.", "mars", "avr.", "mai", "juin", "juil.", "août", "sept.", "oct.", "nov.", "déc.",
    )

    override val openMenu = "Ouvrir le menu"
    override val closeMenu = "Fermer le menu"
}
